import { render } from "./analysis.vue?vue&type=template&id=700ac8b6&scoped=true"
import script from "./analysis.vue?vue&type=script&lang=js"
export * from "./analysis.vue?vue&type=script&lang=js"

import "./analysis.vue?vue&type=style&index=0&id=700ac8b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-700ac8b6"

export default script